// extracted by mini-css-extract-plugin
export var content = "type-page-module--content--VOe1h";
export var rightSidebar = "type-page-module--rightSidebar--3fcvD";
export var typePage = "type-page-module--typePage--vx8v5";
export var typePageContent = "type-page-module--typePageContent--+DtBE";